import React from 'react';

import ElementLabelsToolbarPopupContent from './ElementLabelsToolbarPopupContent';
import { LabelsToolbarPopupProps } from '../labelComponentPropTypes';
import GenericLabelsToolbarPopup from './GenericLabelsToolbarPopup';

import './ElementLabelsToolbarPopup.scss';

const ElementLabelsToolbarPopup: React.FC<LabelsToolbarPopupProps> = (props) => (
    <GenericLabelsToolbarPopup {...props}>
        <ElementLabelsToolbarPopupContent currentUserId={props.currentUserId} closePopup={props.closePopup}/>
    </GenericLabelsToolbarPopup>
);

export default ElementLabelsToolbarPopup;
